import { useResponsive } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { useUpsellsV2 } from '../useUpsellsV2';

export const useIsUpsellScreenEnabled = () => {
  const { minWidth } = useResponsive();

  return useFeatureFlag('CELS-4432-upsell-modal-order') && minWidth.isSM;
};

/**
 * Returns whether the upsell screen should be shown based on feature flag,
 * screen size, and whether there are upsell products available.
 */
export const useShouldShowUpsellScreen = () => {
  const isUpsellScreenEnabled = useIsUpsellScreenEnabled();

  const { upsellProducts, isLoadingUpsells } = useUpsellsV2();

  const hasUpsellProducts = !isLoadingUpsells && upsellProducts.length > 0;

  return isUpsellScreenEnabled && hasUpsellProducts;
};
